/*jslint evil: true */
define(
    ['jquery', 'can/util/jquery', 'jquerypp/view/view', 'can/view/ejs'],
    function($, can){
        $.EJS = can.EJS;
    }
);